<div class="mb-8">

    <div class="w-full flex justify-between mt-8 mb-4">
        <button [routerLink]="['..']"
            class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none mr-3 ease-linear transition-all duration-150"
            type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
            Cancel
        </button>
    </div>

    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">

        <form [formGroup]="pageForm" (ngSubmit)="update()">
            <div class="rounded-t bg-white">
                <div class="rounded-t bg-white mb-0 px-6 py-4">
                    <span class="text-blueGray-700 text-lg font-bold">Edit Member</span>
                </div>
            </div>

            <div class="flex flex-wrap px-6 py-4 bg-blueGray-100">

                <div class="flex flex-row bg-gray-50 border-l-4 border-red-500 mb-6 px-4 py-2 shadow-lg w-full">
                    <div class="bg-red-100 rounded-full h-10 w-10 min-h-10 min-w-10 text-center grid content-center">
                        <i class="fas fa-triangle-exclamation text-lg text-red-500 py-auto"></i>
                    </div>
                    <div class="flex flex-col text-xs ml-4">
                        <p class="text-red-500 block mb-1">Note that member's data privacy is the responsibility of
                            the
                            group admin(s) and member sharing his/her data. AtChurch does not take any responsibility
                            for
                            the user data being shared.
                        </p>
                        <p class="text-primary-500">We recommend that member create an account on
                            AtChurch
                            platform to have full control over their data.
                        </p>
                    </div>
                </div>

                <div class="w-full mb-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Member Image
                    </label>
                    <span class="text-sm text-primary-300">Image file up to 5 Mb only</span>
                    <div class="rounded mt-1 h-[130px]">
                        <uppy-dashboard [uppy]="uppy" [props]="dashboardProps"></uppy-dashboard>
                    </div>
                </div>

                <div class="w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Name *
                    </label>
                    <input type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded capitalize text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Name" formControlName="name" name="name" required>
                    <div
                        class="{{pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                        <p *ngIf="pageForm.get('name')?.errors?.['required']">
                            Value is required
                        </p>
                    </div>
                </div>

                <div class="w-full mb-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Profession
                    </label>
                    <input type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Profession" formControlName="profession" name="profession">
                </div>

                <div class="w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Contact
                    </label>
                    <app-contact formControlName="contact"></app-contact>
                </div>


                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Email
                    </label>
                    <input type="email" type="email" formControlName="email" id="email" name="email"
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                    <div
                        class="{{ pageForm.get('email')?.invalid && (pageForm.get('email')?.dirty || pageForm.get('email')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        <p>{{pageForm.get('email')?.errors?.['email']}}</p>
                    </div>
                </div>

                <div class="flex flex-row gap-4 w-full mb-6">

                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Date of Birth
                        </label>
                        <input type="date" name="dob" formControlName="dob" placeholder="dd/mm/yyyy"
                            class="border-0 px-3 py-3 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            min="1900-01-01" [max]="today">
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            gender
                        </label>
                        <app-gender formControlName="gender"></app-gender>
                    </div>

                </div>

                <div class="w-full mb-6">
                    <app-checkbox formControlName="showDob" label="Show Date of Birth to Group Members"></app-checkbox>
                </div>

                <!-- Address -->
                <div class="flex flex-row gap-4 w-full">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Flat / Villa No
                        </label>
                        <input type="string" name="buildingNo" formControlName="buildingNo"
                            placeholder="House/Flat Number"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        <div class=" pt-1 h-6"></div>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Building Name
                        </label>
                        <input type="string" name="buildingName" formControlName="buildingName"
                            placeholder="Building Name"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        <div class=" pt-1 h-6"></div>
                    </div>
                </div>
                <div class="flex flex-row gap-4 w-full">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Address Line 1
                        </label>
                        <input type="string" name="addressLine1" formControlName="addressLine1"
                            placeholder="Address Line 1"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        <div class=" pt-1 h-6"></div>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Address Line 2
                        </label>
                        <input type="string" name="addressLine2" formControlName="addressLine2"
                            placeholder="Address Line 2"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                    </div>
                </div>
                <div class="flex flex-row gap-4 w-full">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            City *
                        </label>
                        <input type="text" name="city" formControlName="city" placeholder="City" ng-required="true"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            required>
                        <div
                            class="{{pageForm.get('city')?.invalid && (pageForm.get('city')?.dirty || pageForm.get('city')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                            <p *ngIf="pageForm.get('city')?.errors?.['required']">
                                Value is required
                            </p>
                        </div>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Country *
                        </label>
                        <app-country formControlName="country"></app-country>
                    </div>
                </div>

                <div class="w-full rounded h-128 mb-4">
                    <app-add-location [location]="pageForm.get('position')?.value"
                        (locationChange)="setLocation($event)" label="Location" description="Location is only visible to group
                                members"></app-add-location>
                </div>

                <div class="w-full mb-1">
                    <button type="submit" [disabled]="!pageForm.valid || working"
                        class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 focus:outline-none mt-4 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2">
                        <div *ngIf="!working" class="inline-block">
                            <i class="fa fa-save mr-2 leading-relaxed"></i>Update
                        </div>
                        <div *ngIf="working" class="inline-block">
                            <app-loading-dots></app-loading-dots>
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>